var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownwardTrend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 553.73 500.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.39,132.08c2.48-4,4.37-8.58,7.55-11.92,8.39-8.8,21.63-9.36,31.25-1.88a62.67,62.67,0,0,1,5.49,5.08q68.8,68.91,137.56,137.88c1.39,1.39,2.31,3.25,3.62,5.14,2.4-2.29,3.73-3.5,5-4.77q47.46-47.54,94.9-95.08c13.24-13.27,26.24-13.34,39.4-.14q66.63,66.86,133.19,133.76a32.31,32.31,0,0,1,3.18,4.51l1.84-.91v-5.06c0-22.32-.17-44.65.09-67a23.88,23.88,0,0,1,47.76-.15q.21,65.49,0,131A24.2,24.2,0,0,1,507.74,387q-65.36.21-130.71,0a23.63,23.63,0,0,1-23.65-24c0-13.47,10.41-23.88,24.17-23.93,23.77-.08,47.54,0,70.64,0L325.73,216c-.66.63-2,1.83-3.22,3.08q-47.46,47.54-94.9,95.08c-13.41,13.43-26.42,13.46-39.73.12Q110.78,237,33.66,159.81c-5.22-5.21-10-10.55-12.27-17.73Z",
    fill: "#ef3c3a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownwardTrend);
export default __webpack_public_path__ + "static/media/downwardTrend.a386e9737cc43212b056e3884ab96481.svg";
export { ForwardRef as ReactComponent };